export default __webpack_public_path__ + "static/media/resume.01835749.pdf";